module.exports = __webpack_public_path__ + "static/media/home12.208590a5.jpg";